import {Store} from 'redux';
import MockAdapter from 'axios-mock-adapter';
import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';

import * as ApiConst from '../constants/Api';
import * as ActionTypes from '../constants/ActionTypes';

export let mock;

export const configureApi = (store: Store): AxiosInstance => {
    let accessToken = store.getState().user.currentUser.accessToken;
    store.subscribe(() => {
        const currentAccessToken = store.getState().user.currentUser.accessToken;
        if (accessToken !== currentAccessToken) {
            accessToken = currentAccessToken;
        }
    });

    const instance: AxiosInstance = axios.create({
        baseURL: ApiConst.BASE_URL
    });

    instance.interceptors.request.use((config: AxiosRequestConfig) => {
        config.headers.common[ApiConst.HEADER_AUTH_TOKEN] = accessToken ? ("Bearer " + accessToken) : null;

        return config;
    }, error => {
        return Promise.reject(error);
    });

    instance.interceptors.response.use(response => {
        return response;
    }, error => {
        const {
            languages: {
                i18n
            },
            configuration: {
                main: {
                    maxFileSize,
                    maxRequestSize
                }
            }
        } = store.getState();

        // чтобы корректно обрабатывались отменённые ошибки
        if (axios.isCancel(error)) {
            console.log('request cancelled', error.message)
            return Promise.reject(error)
        }

        let message = i18n['api.error.defaultMessage'];


        let excpCode;
        let isShowErrorModal = true;
        if (error.response !== undefined) {
            const {response: {data: {message: errorMessage, exceptionCode: javaExceptionCode, showErrorModal}}} = error;

            if (errorMessage != null) {
                if (errorMessage.includes('FileSizeLimitExceededException')) {
                    message = `${i18n['api.error.fileSizeLimitExceededException']} ${maxFileSize}`;
                } else if (errorMessage.includes('SizeLimitExceededException')) {
                    message = `${i18n['api.error.sizeLimitExceededException']} ${maxRequestSize}`;
                }
            }

            if (errorMessage !== undefined) {
                message = errorMessage;
            }

            if (showErrorModal != undefined && showErrorModal != null) {
                isShowErrorModal = showErrorModal;
            }

            excpCode = javaExceptionCode;
        }

        store.dispatch({
            message,
            isShowErrorModal: isShowErrorModal,
            exceptionCode: excpCode,
            type: ActionTypes.SET_API_ERROR_MODAL_SETTINGS
        });
        return Promise.reject(error);
    });

    instance.accessToken = accessToken;

    if (process.env.NODE_ENV === 'development') {
        mock = new MockAdapter(instance);
    }
    return instance;
};



// WEBPACK FOOTER //
// ./src/api/index.js